import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config';
import { tap } from 'rxjs';
import { gsap } from 'gsap';

@Component({
  selector: 'app-dark-mode-switcher',
  templateUrl: './dark-mode-switcher.component.html',
  styles: [
    `
      :host {
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }

      svg {
        z-index: 2;
        pointer-events: none;
      }

      #day,
      #night {
        width: 70px;
        height: 37px;
        background: white;
        position: absolute;
        z-index: 1;
        cursor: pointer;
        border-radius: 100px;
        background: #9cd6ef;
        border: 3px solid #65c0e7;
      }

      #night {
        pointer-events: none;
      }
    `,
  ],
})
export class DarkModeSwitcherComponent implements AfterViewInit {
  @ViewChild('background') background!: ElementRef;
  @ViewChild('day') day!: ElementRef;
  @ViewChild('night') night!: ElementRef;
  constructor(private _fuseConfigService: FuseConfigService) {}
  ngAfterViewInit(): void {
    if (localStorage.getItem('scheme') == 'dark') {
      this.day.nativeElement.style.pointerEvents = 'all';
      this.night.nativeElement.style.pointerEvents = 'none';

      gsap.set('#sun, #cloud', { opacity: 0 });
      gsap.set('#moon', {
        x: -160,
        rotate: -360,
        transformOrigin: 'center',
        opacity: 1,
      });
      gsap.set('#night', {
        background: '#224fd',
        borderColor: '#cad4d8',
      });
    } else {
      this.day.nativeElement.style.pointerEvents = 'none';
      this.night.nativeElement.style.pointerEvents = 'all';
      gsap.set('#moon, .star', { opacity: 0 });
      gsap.set('#sun, #cloud, #moon', { x: 15 });
      gsap.set('.star', { x: 35, y: -5 });
    }

    this._fuseConfigService.config$
      .pipe(
        tap(cfg => {
          if (cfg.scheme == 'dark') {
            this.switchToDayMode();
          }
          if (cfg.scheme == 'light') {
            this.switchToNightMode();
          }
        })
      )
      .subscribe();
  }

  switchToNightModeWithTime(): void {
    this.day.nativeElement.style.pointerEvents = 'none';
    this.night.nativeElement.style.pointerEvents = 'all';

    this.switchToNightMode();

    setTimeout(() => {
      this._fuseConfigService.config = { scheme: 'light' };
      localStorage.setItem('scheme', 'light');
    }, 200);
  }

  switchToDayModeWithTime(): void {
    this.night.nativeElement.style.pointerEvents = 'none';
    this.day.nativeElement.style.pointerEvents = 'all';
    this.switchToDayMode();

    setTimeout(() => {
      this._fuseConfigService.config = { scheme: 'dark' };
      localStorage.setItem('scheme', 'dark');
    }, 200);
  }

  switchToDayMode() {
    gsap.to('#sun', {
      duration: 0.4,
      x: -157,
      opacity: 0,
      ease: 'power0.inOut',
    });
    gsap.to('#cloud', { duration: 0.2, opacity: 0, ease: 'power0.inOut' });
    gsap.to('#moon', {
      duration: 0.4,
      x: -157,
      rotate: -360,
      transformOrigin: 'center',
      opacity: 1,
      ease: 'power0.inOut',
    });
    gsap.to('.star', { duration: 0.2, opacity: 1, ease: 'power0.inOut' });
    gsap.to('#night', {
      duration: 0.4,
      background: '#224f6d',
      borderColor: '#cad4d8',
      ease: 'power0.inOut',
    });
  }

  switchToNightMode() {
    gsap.to('#sun', {
      duration: 0.4,
      x: 15,
      opacity: 1,
      ease: 'power0.inOut',
    });
    gsap.to('#cloud', { duration: 0.4, opacity: 1, ease: 'power0.inOut' });
    gsap.to('#moon', {
      duration: 0.4,
      opacity: 0,
      x: 35,
      rotate: 360,
      transformOrigin: 'center',
      ease: 'power0.inOut',
    });
    gsap.to('.star', { duration: 0.4, opacity: 0, ease: 'power0.inOut' });
    gsap.to('#night', {
      duration: 0.4,
      background: '#9cd6ef',
      borderColor: '#65c0e7',
      ease: 'power0.inOut',
    });
  }
}
